/**
 * Session (Activity Sessions) Column Definitions
 * Compulsory: Session ID, Time (how long ago based on start_time)
 */

export const AVAILABLE_COLUMNS = {
  session_id: {
    label: 'Session ID',
    field: 'sessionId',
    category: 'core',
    default: true,
    required: true
  },
  time: {
    label: 'Time',
    field: 'startTime',
    category: 'core',
    formatter: 'relativeTime',
    default: true,
    required: true
  },
  user: {
    label: 'User',
    field: 'userDisplay',
    category: 'session',
    default: true
  },
  pages_duration: {
    label: 'Pages / Duration',
    field: 'pagesDuration',
    category: 'session',
    default: true
  },
  country: {
    label: 'Country',
    field: 'country',
    category: 'location',
    default: true
  },
  city: {
    label: 'City',
    field: 'city',
    category: 'location'
  },
  device_type: {
    label: 'Device Type',
    field: 'deviceType',
    category: 'device'
  },
  os: {
    label: 'OS',
    field: 'os',
    category: 'device'
  },
  browser_name: {
    label: 'Browser',
    field: 'browserName',
    category: 'device'
  },
  entry_page: {
    label: 'Entry Page',
    field: 'entryPage',
    category: 'session'
  },
  exit_page: {
    label: 'Exit Page',
    field: 'exitPage',
    category: 'session'
  },
  referrer: {
    label: 'Referrer',
    field: 'referrer',
    category: 'session'
  }
};

export const DEFAULT_COLUMNS = {
  enabled: ['session_id', 'time', 'user', 'pages_duration', 'country'],
  order: ['session_id', 'time', 'user', 'pages_duration', 'country']
};

export const COLUMN_CATEGORIES = {
  core: 'Core',
  session: 'Session',
  location: 'Location',
  device: 'Device'
};

export const getColumnDefinition = (columnKey) => {
  return AVAILABLE_COLUMNS[columnKey] || null;
};

export const getAvailableColumnKeys = () => {
  return Object.keys(AVAILABLE_COLUMNS);
};
